export const WorkHistory = [
  {
    id: 1,
    position: 'QuadCore Technology',
    date: '08/2019 - 11/2021',
    description:
      'Developed and maintained front-end code for various capability landing and detail pages of insight platform application using technologies as HTML, CSS, JavaScript, React and Redux.Also, developing and maintaining the user interface. Implementing design on mobile websites.'
  },
  {
    id: 2,
    position: 'Lendsqr',
    date: '12/2021 - 2022',
    description:
      'Manage full-cycle design task,handling phases from conception to completion while maintaining guidelines throughtout. Verified web-based products fulfilled prescribed projects needs through direct interaction with stakeholders.'
  },
]
